// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BEBto","error":"styles_error__2TXjO","success":"styles_success__1jXbJ"};